import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UIVirtualizedTableWrapper = styled(Box)<{
  height?: number | string;
  bgcolor?: string;
}>(({ theme, height, bgcolor }) => ({
  height: height,
  width: '100%',
  backgroundColor: bgcolor,
  backgroundImage: 'none',
  boxShadow: 'none',
  '& .MuiTableCell-root': {
    backgroundColor: bgcolor,
    borderBottom: `1px solid ${theme.palette.grey[800]}`,
  },
  '& .MuiTableCell-head': {
    backgroundColor: bgcolor,
  },
  '& .MuiTableHead-root': {},
  '& .MuiTableRow-root': {},
  '& .MuiPaper-root,& .MuiPaper-root>div': {
    backgroundColor: bgcolor,
    backgroundImage: 'none',
    boxShadow: 'none',
    overflowX: 'hidden',
  },
}));
